/**
 * Generated by Orval
 * Do not edit manually.
 * Sell To API
 * OpenAPI spec version: v3
 */
import {
  useInfiniteQuery,
  useQuery,
  useSuspenseInfiniteQuery,
  useSuspenseQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseInfiniteQueryResult,
  DefinedUseQueryResult,
  InfiniteData,
  InvalidateOptions,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseInfiniteQueryOptions,
  UseInfiniteQueryResult,
  UseQueryOptions,
  UseQueryResult,
  UseSuspenseInfiniteQueryOptions,
  UseSuspenseInfiniteQueryResult,
  UseSuspenseQueryOptions,
  UseSuspenseQueryResult
} from '@tanstack/react-query';

import type {
  EntitiesPlantDetail,
  EntitiesPlantListResponse,
  ListPlantsParams
} from '../../models';

import { customInstance } from '../../../../services/api';
import type { ErrorType } from '../../../../services/api';
import { customQueryOptions } from '../../../../mutators/customQueryOptions';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === 'queryKey') continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

/**
 * @summary List of plants
 */
export const listPlants = (
    params?: ListPlantsParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<EntitiesPlantListResponse>(
      {url: `/api/v3/plants`, method: 'GET',
        params, signal
    },
      options);
    }




export const getListPlantsInfiniteQueryKey = (params?: ListPlantsParams,) => {
    return [
    'infinite', `/api/v3/plants`, ...(params ? [params] : [])
    ] as const;
    }

export const getListPlantsQueryKey = (params?: ListPlantsParams,) => {
    return [
    `/api/v3/plants`, ...(params ? [params] : [])
    ] as const;
    }


export const useListPlantsInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof listPlants>>>, TError = ErrorType<void>>(params?: ListPlantsParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof listPlants>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListPlantsInfiniteQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listPlants>>> = ({ signal }) => listPlants(params, requestOptions, signal);



      const customOptions = customQueryOptions({ queryKey, queryFn, ...queryOptions});

   return  customOptions as UseInfiniteQueryOptions<Awaited<ReturnType<typeof listPlants>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListPlantsInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof listPlants>>>
export type ListPlantsInfiniteQueryError = ErrorType<void>


export function useListPlantsInfinite<TData = InfiniteData<Awaited<ReturnType<typeof listPlants>>>, TError = ErrorType<void>>(
 params: undefined |  ListPlantsParams, options: { query:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof listPlants>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listPlants>>,
          TError,
          Awaited<ReturnType<typeof listPlants>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListPlantsInfinite<TData = InfiniteData<Awaited<ReturnType<typeof listPlants>>>, TError = ErrorType<void>>(
 params?: ListPlantsParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof listPlants>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listPlants>>,
          TError,
          Awaited<ReturnType<typeof listPlants>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListPlantsInfinite<TData = InfiniteData<Awaited<ReturnType<typeof listPlants>>>, TError = ErrorType<void>>(
 params?: ListPlantsParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof listPlants>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List of plants
 */

export function useListPlantsInfinite<TData = InfiniteData<Awaited<ReturnType<typeof listPlants>>>, TError = ErrorType<void>>(
 params?: ListPlantsParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof listPlants>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = useListPlantsInfiniteQueryOptions(params,options)

  const query = useInfiniteQuery(queryOptions, queryClient) as  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * @summary List of plants
 */
export const prefetchListPlantsInfiniteQuery = async <TData = Awaited<ReturnType<typeof listPlants>>, TError = ErrorType<void>>(
 queryClient: QueryClient, params?: ListPlantsParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof listPlants>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}

  ): Promise<QueryClient> => {

  const queryOptions = useListPlantsInfiniteQueryOptions(params,options)

  await queryClient.infiniteQuery(queryOptions).catch(() => {});

  return queryClient;
}

/**
 * @summary Invalidates the {@link useListPlantsInfinite} query
 */
export const invalidateListPlantsInfinite = async (
 queryClient: QueryClient, params?: ListPlantsParams, options?: InvalidateOptions
  ): Promise<QueryClient> => {

  await queryClient.invalidateQueries({ queryKey: customQueryOptions({ queryKey: getListPlantsInfiniteQueryKey(params) }).queryKey }, options);

  return queryClient;
}




export const useListPlantsQueryOptions = <TData = Awaited<ReturnType<typeof listPlants>>, TError = ErrorType<void>>(params?: ListPlantsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listPlants>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListPlantsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listPlants>>> = ({ signal }) => listPlants(params, requestOptions, signal);



      const customOptions = customQueryOptions({ queryKey, queryFn, ...queryOptions});

   return  customOptions as UseQueryOptions<Awaited<ReturnType<typeof listPlants>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListPlantsQueryResult = NonNullable<Awaited<ReturnType<typeof listPlants>>>
export type ListPlantsQueryError = ErrorType<void>


export function useListPlants<TData = Awaited<ReturnType<typeof listPlants>>, TError = ErrorType<void>>(
 params: undefined |  ListPlantsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listPlants>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listPlants>>,
          TError,
          Awaited<ReturnType<typeof listPlants>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListPlants<TData = Awaited<ReturnType<typeof listPlants>>, TError = ErrorType<void>>(
 params?: ListPlantsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listPlants>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listPlants>>,
          TError,
          Awaited<ReturnType<typeof listPlants>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListPlants<TData = Awaited<ReturnType<typeof listPlants>>, TError = ErrorType<void>>(
 params?: ListPlantsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listPlants>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List of plants
 */

export function useListPlants<TData = Awaited<ReturnType<typeof listPlants>>, TError = ErrorType<void>>(
 params?: ListPlantsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listPlants>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = useListPlantsQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * @summary List of plants
 */
export const prefetchListPlantsQuery = async <TData = Awaited<ReturnType<typeof listPlants>>, TError = ErrorType<void>>(
 queryClient: QueryClient, params?: ListPlantsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listPlants>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}

  ): Promise<QueryClient> => {

  const queryOptions = useListPlantsQueryOptions(params,options)

  await queryClient.query(queryOptions).catch(() => {});

  return queryClient;
}

/**
 * @summary Invalidates the {@link useListPlants} query
 */
export const invalidateListPlants = async (
 queryClient: QueryClient, params?: ListPlantsParams, options?: InvalidateOptions
  ): Promise<QueryClient> => {

  await queryClient.invalidateQueries({ queryKey: customQueryOptions({ queryKey: getListPlantsQueryKey(params) }).queryKey }, options);

  return queryClient;
}




export const useListPlantsSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof listPlants>>, TError = ErrorType<void>>(params?: ListPlantsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof listPlants>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListPlantsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listPlants>>> = ({ signal }) => listPlants(params, requestOptions, signal);



      const customOptions = customQueryOptions({ queryKey, queryFn, ...queryOptions});

   return  customOptions as UseSuspenseQueryOptions<Awaited<ReturnType<typeof listPlants>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListPlantsSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof listPlants>>>
export type ListPlantsSuspenseQueryError = ErrorType<void>


export function useListPlantsSuspense<TData = Awaited<ReturnType<typeof listPlants>>, TError = ErrorType<void>>(
 params: undefined |  ListPlantsParams, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof listPlants>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListPlantsSuspense<TData = Awaited<ReturnType<typeof listPlants>>, TError = ErrorType<void>>(
 params?: ListPlantsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof listPlants>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListPlantsSuspense<TData = Awaited<ReturnType<typeof listPlants>>, TError = ErrorType<void>>(
 params?: ListPlantsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof listPlants>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List of plants
 */

export function useListPlantsSuspense<TData = Awaited<ReturnType<typeof listPlants>>, TError = ErrorType<void>>(
 params?: ListPlantsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof listPlants>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = useListPlantsSuspenseQueryOptions(params,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const useListPlantsSuspenseInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof listPlants>>>, TError = ErrorType<void>>(params?: ListPlantsParams, options?: { query?:Partial<UseSuspenseInfiniteQueryOptions<Awaited<ReturnType<typeof listPlants>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListPlantsInfiniteQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listPlants>>> = ({ signal }) => listPlants(params, requestOptions, signal);



      const customOptions = customQueryOptions({ queryKey, queryFn, ...queryOptions});

   return  customOptions as UseSuspenseInfiniteQueryOptions<Awaited<ReturnType<typeof listPlants>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListPlantsSuspenseInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof listPlants>>>
export type ListPlantsSuspenseInfiniteQueryError = ErrorType<void>


export function useListPlantsSuspenseInfinite<TData = InfiniteData<Awaited<ReturnType<typeof listPlants>>>, TError = ErrorType<void>>(
 params: undefined |  ListPlantsParams, options: { query:Partial<UseSuspenseInfiniteQueryOptions<Awaited<ReturnType<typeof listPlants>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListPlantsSuspenseInfinite<TData = InfiniteData<Awaited<ReturnType<typeof listPlants>>>, TError = ErrorType<void>>(
 params?: ListPlantsParams, options?: { query?:Partial<UseSuspenseInfiniteQueryOptions<Awaited<ReturnType<typeof listPlants>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListPlantsSuspenseInfinite<TData = InfiniteData<Awaited<ReturnType<typeof listPlants>>>, TError = ErrorType<void>>(
 params?: ListPlantsParams, options?: { query?:Partial<UseSuspenseInfiniteQueryOptions<Awaited<ReturnType<typeof listPlants>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List of plants
 */

export function useListPlantsSuspenseInfinite<TData = InfiniteData<Awaited<ReturnType<typeof listPlants>>>, TError = ErrorType<void>>(
 params?: ListPlantsParams, options?: { query?:Partial<UseSuspenseInfiniteQueryOptions<Awaited<ReturnType<typeof listPlants>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseSuspenseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = useListPlantsSuspenseInfiniteQueryOptions(params,options)

  const query = useSuspenseInfiniteQuery(queryOptions, queryClient) as  UseSuspenseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * @summary Show plant
 */
export const showPlant = (
    id: number,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<EntitiesPlantDetail>(
      {url: `/api/v3/plants/${id}`, method: 'GET', signal
    },
      options);
    }




export const getShowPlantInfiniteQueryKey = (id: number,) => {
    return [
    'infinite', `/api/v3/plants/${id}`
    ] as const;
    }

export const getShowPlantQueryKey = (id: number,) => {
    return [
    `/api/v3/plants/${id}`
    ] as const;
    }


export const useShowPlantInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof showPlant>>>, TError = ErrorType<unknown>>(id: number, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof showPlant>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getShowPlantInfiniteQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof showPlant>>> = ({ signal }) => showPlant(id, requestOptions, signal);



      const customOptions = customQueryOptions({ queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions});

   return  customOptions as UseInfiniteQueryOptions<Awaited<ReturnType<typeof showPlant>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ShowPlantInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof showPlant>>>
export type ShowPlantInfiniteQueryError = ErrorType<unknown>


export function useShowPlantInfinite<TData = InfiniteData<Awaited<ReturnType<typeof showPlant>>>, TError = ErrorType<unknown>>(
 id: number, options: { query:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof showPlant>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof showPlant>>,
          TError,
          Awaited<ReturnType<typeof showPlant>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useShowPlantInfinite<TData = InfiniteData<Awaited<ReturnType<typeof showPlant>>>, TError = ErrorType<unknown>>(
 id: number, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof showPlant>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof showPlant>>,
          TError,
          Awaited<ReturnType<typeof showPlant>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useShowPlantInfinite<TData = InfiniteData<Awaited<ReturnType<typeof showPlant>>>, TError = ErrorType<unknown>>(
 id: number, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof showPlant>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Show plant
 */

export function useShowPlantInfinite<TData = InfiniteData<Awaited<ReturnType<typeof showPlant>>>, TError = ErrorType<unknown>>(
 id: number, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof showPlant>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = useShowPlantInfiniteQueryOptions(id,options)

  const query = useInfiniteQuery(queryOptions, queryClient) as  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * @summary Show plant
 */
export const prefetchShowPlantInfiniteQuery = async <TData = Awaited<ReturnType<typeof showPlant>>, TError = ErrorType<unknown>>(
 queryClient: QueryClient, id: number, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof showPlant>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}

  ): Promise<QueryClient> => {

  const queryOptions = useShowPlantInfiniteQueryOptions(id,options)

  await queryClient.infiniteQuery(queryOptions).catch(() => {});

  return queryClient;
}

/**
 * @summary Invalidates the {@link useShowPlantInfinite} query
 */
export const invalidateShowPlantInfinite = async (
 queryClient: QueryClient, id: number, options?: InvalidateOptions
  ): Promise<QueryClient> => {

  await queryClient.invalidateQueries({ queryKey: customQueryOptions({ queryKey: getShowPlantInfiniteQueryKey(id) }).queryKey }, options);

  return queryClient;
}




export const useShowPlantQueryOptions = <TData = Awaited<ReturnType<typeof showPlant>>, TError = ErrorType<unknown>>(id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof showPlant>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getShowPlantQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof showPlant>>> = ({ signal }) => showPlant(id, requestOptions, signal);



      const customOptions = customQueryOptions({ queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions});

   return  customOptions as UseQueryOptions<Awaited<ReturnType<typeof showPlant>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ShowPlantQueryResult = NonNullable<Awaited<ReturnType<typeof showPlant>>>
export type ShowPlantQueryError = ErrorType<unknown>


export function useShowPlant<TData = Awaited<ReturnType<typeof showPlant>>, TError = ErrorType<unknown>>(
 id: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof showPlant>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof showPlant>>,
          TError,
          Awaited<ReturnType<typeof showPlant>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useShowPlant<TData = Awaited<ReturnType<typeof showPlant>>, TError = ErrorType<unknown>>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof showPlant>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof showPlant>>,
          TError,
          Awaited<ReturnType<typeof showPlant>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useShowPlant<TData = Awaited<ReturnType<typeof showPlant>>, TError = ErrorType<unknown>>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof showPlant>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Show plant
 */

export function useShowPlant<TData = Awaited<ReturnType<typeof showPlant>>, TError = ErrorType<unknown>>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof showPlant>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = useShowPlantQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * @summary Show plant
 */
export const prefetchShowPlantQuery = async <TData = Awaited<ReturnType<typeof showPlant>>, TError = ErrorType<unknown>>(
 queryClient: QueryClient, id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof showPlant>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}

  ): Promise<QueryClient> => {

  const queryOptions = useShowPlantQueryOptions(id,options)

  await queryClient.query(queryOptions).catch(() => {});

  return queryClient;
}

/**
 * @summary Invalidates the {@link useShowPlant} query
 */
export const invalidateShowPlant = async (
 queryClient: QueryClient, id: number, options?: InvalidateOptions
  ): Promise<QueryClient> => {

  await queryClient.invalidateQueries({ queryKey: customQueryOptions({ queryKey: getShowPlantQueryKey(id) }).queryKey }, options);

  return queryClient;
}




export const useShowPlantSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof showPlant>>, TError = ErrorType<unknown>>(id: number, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof showPlant>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getShowPlantQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof showPlant>>> = ({ signal }) => showPlant(id, requestOptions, signal);



      const customOptions = customQueryOptions({ queryKey, queryFn, ...queryOptions});

   return  customOptions as UseSuspenseQueryOptions<Awaited<ReturnType<typeof showPlant>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ShowPlantSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof showPlant>>>
export type ShowPlantSuspenseQueryError = ErrorType<unknown>


export function useShowPlantSuspense<TData = Awaited<ReturnType<typeof showPlant>>, TError = ErrorType<unknown>>(
 id: number, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof showPlant>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useShowPlantSuspense<TData = Awaited<ReturnType<typeof showPlant>>, TError = ErrorType<unknown>>(
 id: number, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof showPlant>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useShowPlantSuspense<TData = Awaited<ReturnType<typeof showPlant>>, TError = ErrorType<unknown>>(
 id: number, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof showPlant>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Show plant
 */

export function useShowPlantSuspense<TData = Awaited<ReturnType<typeof showPlant>>, TError = ErrorType<unknown>>(
 id: number, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof showPlant>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = useShowPlantSuspenseQueryOptions(id,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const useShowPlantSuspenseInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof showPlant>>>, TError = ErrorType<unknown>>(id: number, options?: { query?:Partial<UseSuspenseInfiniteQueryOptions<Awaited<ReturnType<typeof showPlant>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getShowPlantInfiniteQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof showPlant>>> = ({ signal }) => showPlant(id, requestOptions, signal);



      const customOptions = customQueryOptions({ queryKey, queryFn, ...queryOptions});

   return  customOptions as UseSuspenseInfiniteQueryOptions<Awaited<ReturnType<typeof showPlant>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ShowPlantSuspenseInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof showPlant>>>
export type ShowPlantSuspenseInfiniteQueryError = ErrorType<unknown>


export function useShowPlantSuspenseInfinite<TData = InfiniteData<Awaited<ReturnType<typeof showPlant>>>, TError = ErrorType<unknown>>(
 id: number, options: { query:Partial<UseSuspenseInfiniteQueryOptions<Awaited<ReturnType<typeof showPlant>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useShowPlantSuspenseInfinite<TData = InfiniteData<Awaited<ReturnType<typeof showPlant>>>, TError = ErrorType<unknown>>(
 id: number, options?: { query?:Partial<UseSuspenseInfiniteQueryOptions<Awaited<ReturnType<typeof showPlant>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useShowPlantSuspenseInfinite<TData = InfiniteData<Awaited<ReturnType<typeof showPlant>>>, TError = ErrorType<unknown>>(
 id: number, options?: { query?:Partial<UseSuspenseInfiniteQueryOptions<Awaited<ReturnType<typeof showPlant>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Show plant
 */

export function useShowPlantSuspenseInfinite<TData = InfiniteData<Awaited<ReturnType<typeof showPlant>>>, TError = ErrorType<unknown>>(
 id: number, options?: { query?:Partial<UseSuspenseInfiniteQueryOptions<Awaited<ReturnType<typeof showPlant>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseSuspenseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = useShowPlantSuspenseInfiniteQueryOptions(id,options)

  const query = useSuspenseInfiniteQuery(queryOptions, queryClient) as  UseSuspenseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






